import { render, staticRenderFns } from "./AISupportBox.vue?vue&type=template&id=01c838c4&scoped=true&"
import script from "./AISupportBox.vue?vue&type=script&lang=js&"
export * from "./AISupportBox.vue?vue&type=script&lang=js&"
import style0 from "./AISupportBox.vue?vue&type=style&index=0&id=01c838c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c838c4",
  null
  
)

export default component.exports